(function(){
  var dataEl=document.getElementById('og-product-json');
  var product=dataEl?JSON.parse(dataEl.textContent):null;
  var mainMedia=document.getElementById('og-main-media');
  var slides=mainMedia?Array.prototype.slice.call(mainMedia.querySelectorAll('.og-slide')):[];
  var thumbs=Array.prototype.slice.call(document.querySelectorAll('.og-thumb'));
  function isMobile(){return window.innerWidth<750;}
  function showSlide(idx){
    if(isMobile()){
      if(mainMedia)mainMedia.scrollTo({left:idx*mainMedia.clientWidth,behavior:'smooth'});
    }else{
      slides.forEach(function(s,i){s.classList.toggle('is-active',i===idx);});
      thumbs.forEach(function(t,i){t.classList.toggle('is-active',i===idx);});
    }
  }
  thumbs.forEach(function(t){t.addEventListener('click',function(){showSlide(parseInt(t.dataset.media));});});
  if(!product)return;
  var form=document.getElementById('og-product-form');
  var variantInput=document.getElementById('og-variant-id');
  var atcBtn=document.getElementById('og-btn-atc');
  var atcBtnLabel=atcBtn?atcBtn.querySelector('span'):null;
  var priceWrap=document.getElementById('og-price-wrap');
  var moneyFormat=window.ogMoneyFormat||'€{{amount_with_comma_separator}}';
  function formatMoney(cents){
    var v=(cents/100).toFixed(2).replace('.',',');
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/,v);
  }
  function currentOptions(){
    var opts=[];
    if(!form)return opts;
    var groups=form.querySelectorAll('.og-option-group');
    groups.forEach(function(g){
      var checked=g.querySelector('.og-opt-radio:checked');
      opts.push(checked?checked.value:null);
    });
    return opts;
  }
  function findVariant(opts){
    return product.variants.find(function(v){
      return opts.every(function(o,i){return !o||v.options[i]===o;});
    });
  }
  function updateVariant(){
    var v=findVariant(currentOptions());
    if(!v)return;
    if(variantInput)variantInput.value=v.id;
    if(atcBtn){
      if(v.available){atcBtn.disabled=false;atcBtn.classList.remove('og-btn-soldout');if(atcBtnLabel)atcBtnLabel.textContent='Add to Cart';}
      else{atcBtn.disabled=true;atcBtn.classList.add('og-btn-soldout');if(atcBtnLabel)atcBtnLabel.textContent='Sold Out';}
    }
    if(priceWrap){
      var html='';
      var pct;
      if(v.compare_at_price&&v.compare_at_price>v.price){
        pct=Math.round((v.compare_at_price-v.price)*100/v.compare_at_price);
        html='<span class="og-price og-price--sale">'+formatMoney(v.price)+'</span>'
            +'<span class="og-price og-price--compare">'+formatMoney(v.compare_at_price)+'</span>'
            +'<span class="og-price--save">Save '+pct+'%</span>';
      }else{
        html='<span class="og-price og-price--regular">'+formatMoney(v.price)+'</span>';
      }
      priceWrap.innerHTML=html;
      var sp=document.getElementById('og-sticky-price');
      if(sp)sp.innerHTML='<span class="og-price--sale">'+formatMoney(v.price)+'</span>'+(v.compare_at_price&&v.compare_at_price>v.price?'<span class="og-price--compare">'+formatMoney(v.compare_at_price)+'</span>':'');
    }
    var sBtn=document.getElementById('og-sticky-btn');
    if(sBtn){
      if(v.available){sBtn.disabled=false;sBtn.classList.remove('og-btn-soldout');sBtn.textContent='Add to Cart';}
      else{sBtn.disabled=true;sBtn.classList.add('og-btn-soldout');sBtn.textContent='Sold Out';}
    }
    if(v.featured_media){
      var idx=slides.findIndex(function(s){return s.dataset.mediaId==v.featured_media.id;});
      if(idx>=0)showSlide(idx);
    }
    try{
      var url=new URL(window.location.href);
      url.searchParams.set('variant',v.id);
      window.history.replaceState({},'',url.toString());
    }catch(e){}
  }
  if(form)form.addEventListener('change',function(e){if(e.target.classList.contains('og-opt-radio'))updateVariant();});
  var stickyBar=document.getElementById('og-sticky-atc');
  var stickyBtn=document.getElementById('og-sticky-btn');
  if(stickyBtn){
    stickyBtn.addEventListener('click',function(e){
      if(product&&product.variants&&product.variants.length>1){
        e.preventDefault();
        var target=document.querySelector('.og-option-group')||form;
        if(target)target.scrollIntoView({behavior:'smooth',block:'center'});
      }
    });
  }
  if(stickyBar&&atcBtn&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      stickyBar.classList.toggle('is-visible',!entries[0].isIntersecting);
    },{threshold:0});
    io.observe(atcBtn);
  }
})();
